<template>
  <v-chart ref="chart" class="chart" :option="option" @click="click1"/>
</template>

<script>
export default {
  name: 'stackChart2',
  props: {
    avadata: Object,
    simpleavadata: Object,
    showDemo: String
  },
  data() {
    return {
      option: { },
      owndata: {}
    }
  },
  watch: {
    treemapdata: {
      handler(newValue, oldValue) {
        this.owndata = newValue
        this.getDataView()
      }
    }
  },
  mounted() {
    console.log('[stackChart/mounted]')
    this.$nextTick(() => {
      if (this.showDemo == 'true') {
        this.owndata = this.avadata
        this.getDataView()
      } else {
        this.owndata = this.simpleavadata
        setTimeout(() => {
          this.getDataView()
        }, 2000)
      }
    })
  },
  methods: {
    getDataView() {
      console.log('[stackChart/getDataView]');
      // this.axios.get('api/kcapi/get_sexandage').then((response) => {
      console.log(this.owndata)
      this.option = {
          title: {
            //text: 'Stacked Line'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            //data: ['China', 'EU27', 'Germany', 'India', 'Japan', 'Russia', 'STLCs', 'UK', 'USA']
            data: ['China', 'Germany', 'India', 'Japan', 'Russia', 'UK', 'USA']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1996','1997','1998','1999','2000','2001','2002','2003','2004','2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018','2019','2020','2021']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'China',
              type: 'line',
              data: [0.20,0.18,0.17,0.18,0.17,0.16,0.17,0.17,0.18,0.18,0.18,0.19,0.20,0.20,0.21,0.21,0.23,0.25,0.27,0.30,0.32,0.34,0.37,0.39,0.45,0.52]
            },
            {
              name: 'Germany',
              type: 'line',
              data: [0.31,0.31,0.32,0.32,0.32,0.32,0.33,0.34,0.35,0.36,0.37,0.37,0.38,0.39,0.41,0.41,0.42,0.43,0.45,0.46,0.48,0.49,0.51,0.52,0.57,0.63]
            },
            {
              name: 'India',
              type: 'line',
              data: [0.12,0.12,0.11,0.12,0.12,0.12,0.13,0.12,0.13,0.13,0.13,0.13,0.13,0.13,0.14,0.14,0.15,0.16,0.17,0.17,0.18,0.19,0.19,0.20,0.23,0.26]
            },
            {
              name: 'Japan',
              type: 'line',
              data: [0.19,0.19,0.19,0.19,0.19,0.19,0.19,0.21,0.20,0.20,0.21,0.22,0.22,0.22,0.23,0.23,0.23,0.24,0.25,0.27,0.27,0.28,0.30,0.31,0.35,0.40]
            },
            {
              name: 'Russia',
              type: 'line',
              data: [0.14,0.14,0.14,0.14,0.15,0.14,0.14,0.15,0.15,0.16,0.16,0.15,0.15,0.16,0.16,0.16,0.15,0.16,0.17,0.19,0.19,0.20,0.21,0.22,0.25,0.27]
            },
            {
              name: 'UK',
              type: 'line',
              data: [0.32,0.32,0.32,0.32,0.32,0.32,0.33,0.35,0.35,0.36,0.37,0.39,0.40,0.41,0.42,0.43,0.44,0.46,0.49,0.51,0.53,0.54,0.56,0.57,0.61,0.67]
            },
            {
              name: 'USA',
              type: 'line',
              data: [0.42,0.41,0.41,0.42,0.42,0.42,0.44,0.46,0.48,0.49,0.50,0.53,0.54,0.58,0.59,0.61,0.63,0.66,0.76,0.79,0.80,0.82,0.85,0.86,0.91,0.99]
            }
          ]
      }
      // }).catch((response) => {
      //   console.log(response)
      // })
      this.$refs['chart'].setOption(this.option);

    },
    resize() {
      this.$refs['chart'].resize()
    },

    click1(params){
        console.log('[stackChart1/click1]', params, params.name);
        //window.open('https://www.baidu.com/s?wd=' + encodeURIComponent(params.name));
        this.$emit('chgYear', params.name);
    }
  }
}
</script>

<style>

</style>
